var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full flex flex-col relative overflow-x-hidden"},[_c('swiper',{ref:"mySwiper",staticClass:"swiper h-full w-full",attrs:{"options":_vm.swiperOptions}},[_c('SlideSL',{attrs:{"sortBy":_vm.sortBy},on:{"nextPage":_vm.nextPage,"changeSortBy":_vm.changeSortBy}}),_c('SlideSMU',{attrs:{"sortBy":_vm.sortBy}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }